import PropTypes from 'prop-types'
import React from 'react'

import { chainDecorators, memoized } from '../../utils/ReactUtils'
import ImageStatic from '../ImageStatic'
import Link from '../Link'

import styles from './styles'


const decorators = [
  memoized,
]

function ContactBlock(props) {
  const { office, city, email, phone, address, color, icon } = props
  const split = office.indexOf('%s') !== -1 ? [
    office.substring(0, office.indexOf('%s')),
    office.substring(office.indexOf('%s') + 2),
  ] : [office, '']

  return (
    <div className="container">
      <address className={color}>
        <p>
          {`${split[0]}`}
          <Link
            className="city"
            link={`http://maps.google.com/maps?f=d&daddr=${encodeURI(address)}`}
            rel="noopener"
          >
            {city}
          </Link>
          {`${split[1]}`}
        </p>
        <Link
          link={`mailto:${email}`}
          rel="noopener"
          className="email"
        >
          {email}
        </Link>
        {phone
        && (
        <Link
          link={`tel:${phone.split(' ').join('')}`}
          rel="noopener"
        >
          {phone}
        </Link>
        )
        }
        <Link
          link={`http://maps.google.com/maps?f=d&daddr=${encodeURI(address)}`}
          rel="noopener"
        >
          {address}
        </Link>
      </address>
      {icon
      && (
      <aside>
        <ImageStatic src={`/images/icons/${icon}.svg`} />
      </aside>
      )
      }
      <style jsx>{styles}</style>
    </div>
  )
}

ContactBlock.colors = {
  blue: 'blue',
  pink: 'pink',
}

ContactBlock.icons = {
  nice: 'nice',
  paris: 'paris',
  none: '',
}

ContactBlock.propTypes = {
  office: PropTypes.string,
  city: PropTypes.string.isRequired,
  phone: PropTypes.string,
  email: PropTypes.string.isRequired,
  address: PropTypes.string.isRequired,
  color: PropTypes.oneOf(Object.values(ContactBlock.colors)).isRequired,
  icon: PropTypes.oneOf(Object.values(ContactBlock.icons)),
}

ContactBlock.defaultProps = {
  office: '',
  icon: '',
  phone: '',
}

ContactBlock = chainDecorators(decorators, ContactBlock)

export default ContactBlock
